import useAppRouter from "@/helpers/hooks/useAppRouter";

export const ROUTES = {
  home: "/",
  about_us: "/about-us",
  contact_us: "/contact-us",
  privacy_policy: "/privacy-policy",
  ads: "/ads",
  anavatan: "/anavatan",
  auth: {
    login: "/auth/login",
    register: "/auth/register",
  },
  profile: {
    account: "/profile/account",
    devices: "/profile/devices",
    history: "/profile/history",
    favourites: "/profile/favourites",
    subscription: "/profile/subscription",
    transactions: "/profile/transactions",
    deactive: "/profile/deactive",
    chat: "/profile/chat",
  },
  cooperation: "/cooperation",
  subscription: "/subscription",
  category: "/category",
  genre: "/genre",
  movie: "/movie",
  animation: "/movie",
  music: "/music",
  series: "/series",
  program: "/program",
  sport: "/movie",
  search: "/search",
  comingSoon: "/coming-soon",
  player: "/player",
  artists: "/artists",
  online_cinema: "/online-cinema",
  online_bakhish: "/online-bakhish",
  live: "/live",
  privacy_policy: "/privacy-policy",
  free: "/free",
  zheton: "/zheton",
  buyTicket: "/buy-ticket",
  faq: "/faq",
};
